<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Inspection & Audit</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <!-- <li class="breadcrumb-item active" aria-current="page">{{ 'INSPECTION.INSPECTIONS' | translate }}</li> -->
            <li class="breadcrumb-item" aria-current="page">
              {{ "INSPECTION.INSPECTIONS_OVERVIEW" | translate }}
            </li>
            <li class="filter-sort">
              <div
                class="filter-sort-wrapper"
                (clickOutside)="onClickedOutside()"
              >
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#filter"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-filter"
                    aria-hidden="true"
                    pTooltip="Filter"
                    tooltipPosition="top"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideFilter">
                  <ul class="filter-section-wrapper collapse" id="filter">
                    <li class="no-padding-left">
                      <div class="leave-type">
                        <h5>{{ "INSPECTION.CHECKLIST" | translate }}</h5>
                        <p-multiSelect
                          [options]="inspectionCheckLists"
                          [(ngModel)]="selectedCheckLists"
                        >
                        </p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "INSPECTION.STATUS" | translate }}</h5>
                        <p-multiSelect
                          [options]="inspectionStatus"
                          [(ngModel)]="selectedStatusId"
                        >
                        </p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "INSPECTION.INSPECTION_DATE" | translate }}</h5>
                        <div class="col-lg-12 col-md-11 col-sm-11 no-padding">
                          <div
                            class="col-lg-6 col-md-6 col-sm-6 no-padding-left"
                          >
                            <p-calendar
                              [showIcon]="true"
                              [showTime]="true"
                              placeholder="From"
                              dateFormat="dd/mm/yy"
                              [(ngModel)]="inspectionFromDate"
                              class="custom-datepicker"
                              readonlyInput="true"
                              required
                              #timeOfUse="ngModel"
                              monthNavigator="true"
                              yearNavigator="true"
                              yearRange="1950:2100"
                              showButtonBar="true"
                            >
                            </p-calendar>
                          </div>
                          <div
                            class="col-lg-6 col-md-6 col-sm-6 no-padding-right"
                          >
                            <p-calendar
                              [showIcon]="true"
                              [minDate]="inspectionFromDate"
                              dateFormat="dd/mm/yy"
                              [showTime]="true"
                              placeholder="To"
                              [(ngModel)]="inspectionToDate"
                              class="custom-datepicker"
                              readonlyInput="true"
                              required
                              #timeOfUse="ngModel"
                              monthNavigator="true"
                              yearNavigator="true"
                              yearRange="1950:2100"
                              showButtonBar="true"
                            >
                            </p-calendar>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </li>
                    <li class="no-padding-right">
                      <h5>Unit</h5>
                      <p-multiSelect
                        [options]="unitList"
                        [(ngModel)]="selectedUnit"
                      ></p-multiSelect>
                    </li>
                    <div class="clearfix"></div>
                    <li class="filter-footer">
                      <footer>
                        <a
                          (click)="resetFilter()"
                          role="button"
                          class="btn btn-primary primary-btn button-reset"
                        >
                          <i class="fa fa-refresh"></i>reset
                        </a>
                        <a
                          (click)="doneFilter()"
                          role="button"
                          class="btn btn-primary primary-btn button-submit"
                        >
                          <i class="fa fa-check"></i>done
                        </a>
                      </footer>
                    </li>
                  </ul>
                </div>
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#sort"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-sort"
                    aria-hidden="true"
                    pTooltip="Sort"
                    tooltipPosition="top"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideSort">
                  <ul
                    class="filter-section-wrapper sort-section-wrapper collapse"
                    id="sort"
                  >
                    <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>
                            {{ "INSPECTION.INSPECTION_ID" | translate }}</label
                          >
                          <a class="selected">
                            <i
                              (click)="ascInspectionId()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="">
                            <i
                              (click)="descInspectionId()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li class="no-margin-right">
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>{{
                            "INSPECTION.INSPECTION_DATE" | translate
                          }}</label>
                          <a class="">
                            <i
                              (click)="ascInspectionDate()"
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a class="selected">
                            <i
                              (click)="descInspectionDate()"
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                  </ul>
                </div>
              </div>
              <div class="clearfix"></div>
            </li>
          </ol>
        </nav>
        <div class="section-wrapper margin-top-10">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div class="col-lg-7 col-md-6 col-sm-6 col-xs-6 no-padding">
              <a
                [ngClass]="
                  inspectionData.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="exportToExcel()"
                class="btn btn-primary primary-btn export-btn button-excel"
                role="button"
              >
                <i class="fa fa-file-excel-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To Excel
              </a>
              <a
                [ngClass]="
                  inspectionData.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="downloadZIP()"
                class="btn btn-primary primary-btn export-btn button-zip"
                role="button"
              >
                <i class="fa fa-file-zip-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To ZIP
              </a>
            </div>
            <div
              class="col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding align-right"
            >
              <input
                type="text"
                placeholder="Search"
                class="form-control search-obs"
                [(ngModel)]="searchText"
                (keyup.enter)="searchData()"
              />
              <button class="btn btn-primary primary-btn">
                <i
                  class="fa fa-search search"
                  (click)="searchData()"
                  [class.padding]="searchText.length > 0"
                ></i>
                <i
                  class="fa fa-close clear"
                  *ngIf="searchText.length > 0"
                  (click)="clearSearch()"
                ></i>
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
          <div class="table-responsive margin-top-15 observation-table">
            <table
              class="table table-bordered table-striped table-condensed fix-tablelayout"
            >
              <thead>
                <tr>
                  <th style="width: 30px">
                    <input
                      type="checkbox"
                      [checked]="isInspectionsChecked"
                      (change)="selectAllInspections($event.target.checked)"
                      [(ngModel)]="isInspectionsChecked"
                      [value]="isInspectionsChecked"
                    />
                  </th>
                  <th style="width: 70px">{{ "INSPECTION.ID" | translate }}</th>
                  <th style="width: 150px">
                    {{ "INSPECTION.UNIT" | translate }}
                  </th>
                  <th style="width: 130px">
                    Contract Number 
                  </th>
                  <th style="width: 130px">
                    Inspector Name
                  </th>
                  <th style="width: 130px">
                    {{ "INSPECTION.INSPECTION_NAME" | translate }}
                  </th>
                 
                  <th style="width: 265px">
                    {{ "INSPECTION.INSPECTION_DESCRIPTION" | translate }}
                  </th>
                  <th style="width: 150px">
                    {{ "INSPECTION.CONTRACTOR_NAME" | translate }}
                  </th>
                  <th style="width: 200px">
                    {{ "INSPECTION.INSPECTION_DATE" | translate }}
                  </th>
                  <th style="width: 200px">
                    {{ "INSPECTION.SUBMISSION_DATE" | translate }}
                  </th>
                  <!-- <th style="width: 70px">{{ 'INSPECTION.REPORT' | translate }}</th> -->
                  <th style="width: 120px">
                    {{ "INSPECTION.STATUS" | translate }}
                  </th>
                  <th style="width: 120px">
                    {{ "INSPECTION.DOWNLOAD" | translate }}
                  </th>

                  <th style="width: 120px" *ngIf="permissions.SUPER_Admin" >Action</th>
         	
                </tr>
              </thead>
              <tbody>
                <tr
                  (contextmenu)="cm.show($event); showContextMenu(inspection)"
                  #row
                  style="cursor: pointer"
                  id="{{ inspection.InspectionRequestId }}"
                  *ngFor="
                    let inspection of inspectionData
                      | paginate
                        : {
                            itemsPerPage: itemPerPage,
                            currentPage: pageSize,
                            totalItems: rowCount
                          }
                  "
                >
                  <td>
                    <span *ngIf="inspection.Status === 'Draft'">
                      <input
                        type="checkbox"
                        [disabled]="inspection.Status === 'Draft'"
                        (change)="selectInspection(inspection, $event)"
                        [value]="inspection"
                      />
                    </span>
                    <span *ngIf="inspection.Status !== 'Draft'">
                      <input
                        type="checkbox"
                        [(ngModel)]="inspection.Checked"
                        [checked]="inspection.Checked"
                        (change)="selectInspection(inspection, $event)"
                        [value]="inspection"
                      />
                    </span>
                  </td>
                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    <span
                      *ngIf="inspection.Status === 'Draft'"
                      style="color: red"
                      >Draft</span
                    >
                    <span *ngIf="inspection.Status !== 'Draft'"
                      >INS{{ inspection.InspectionRequestId }}</span
                    >
                  </td>
                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    {{ inspection.UnitName }}
                  </td>

                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    {{ inspection.ContractNumber }}
                  </td>
                  
                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    {{ inspection.InspectorFullName }}
                  </td>
                  
                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    <div
                      class="ellepsis-obs"
                      [popover]="inspection.InspectionName"
                      popoverTitle="Inspection Name"
                      popoverPlacement="bottom"
                      [popoverOnHover]="true"
                      [popoverCloseOnClickOutside]="true"
                      [popoverCloseOnMouseOutside]="false"
                      [popoverDisabled]="false"
                      [popoverAnimation]="true"
                      [popoverDismissTimeout]="0"
                    >
                    {{ inspection.InspectionName }}
                    </div>

                    
                  </td>
                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    <div
                      class="ellepsis-obs"
                      [popover]="inspection.InspectionDescription"
                      popoverTitle="Inspection Description"
                      popoverPlacement="bottom"
                      [popoverOnHover]="true"
                      [popoverCloseOnClickOutside]="true"
                      [popoverCloseOnMouseOutside]="false"
                      [popoverDisabled]="false"
                      [popoverAnimation]="true"
                      [popoverDismissTimeout]="0"
                    >
                    {{ inspection.InspectionDescription }}
                    </div>

                    
                  </td>
                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    {{ inspection.ContractorName }}
                  </td>
                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    {{ inspection.InspectionDate | dateTimeFormat }}
                  </td>
                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    {{ inspection.CreatedDate | dateTimeFormat }}
                  </td>
                  <!-- <td><a *ngIf="inspection.ReportURL" [href]="inspection.ReportURL" target="_blank"><i
                        class="fa fa-eye"></i></a></td> -->
                  <td (click)="goToInspection(inspection.InspectionRequestId)">
                    {{ inspection.Status }}
                  </td>
                  <td (click)="downloadPDF(inspection.InspectionRequestId)">
                    <i class="fa fa-download"></i>
                  </td>

                  <td *ngIf="permissions.SUPER_Admin">
                    <ara-record-actions *ngIf="inspection.Status === 'Deleted'" [SourceId]="inspection.InspectionRequestId" ModuleName="Inspection" ShowRestore="true"  [ShowLabel]="false"  (output)="getOutput($event)" >

                    </ara-record-actions>
                  </td>
				  
                </tr>
              </tbody>
              <div
                style="width: 500px; margin-top: 15px; color: red"
                *ngIf="inspectionData.length === 0"
              >
                No Records Found!
              </div>
              <div style="width: 500px" *ngIf="showPagination">
                <pagination-controls
                  (pageChange)="getServerData($event)"
                ></pagination-controls>
              </div>
            </table>
          </div>
          <div class="card-view">
            <label class="checkbox-inline margin-bottom-10 pull-right"
              ><input
                type="checkbox"
                [checked]="isInspectionsChecked"
                (change)="selectAllInspections($event.target.checked)"
                [(ngModel)]="isInspectionsChecked"
                [value]="isInspectionsChecked"
              />Select All</label
            >
            <div class="clearfix"></div>
            <div
              class="card"
              *ngFor="
                let inspection of inspectionData
                  | paginate
                    : {
                        itemsPerPage: itemPerPage,
                        currentPage: pageSize,
                        totalItems: rowCount
                      }
              "
            >
              <div
                [popover]="inspection.InspectionDescription"
                popoverTitle="Inspection Description"
                popoverPlacement="bottom"
                [popoverOnHover]="false"
                [popoverCloseOnClickOutside]="true"
                [popoverCloseOnMouseOutside]="true"
                [popoverDisabled]="false"
                [popoverAnimation]="true"
                [popoverDismissTimeout]="0"
              >
                <h5 class="card-title">
                  <span class="ellepsis-mobile">{{
                    inspection.InspectionDescription
                  }}</span>
                  <span>
                    <input
                      type="checkbox"
                      [(ngModel)]="inspection.Checked"
                      [checked]="inspection.Checked"
                      (change)="selectInspection(inspection, $event)"
                      [value]="inspection"
                  /></span>
                </h5>
              </div>
              <p
                class="card-sub-title"
                (click)="goToInspection(inspection.InspectionRequestId)"
              >
                <span>INS{{ inspection.InspectionRequestId }}</span> -
                <span>{{ inspection.UnitName }}</span>
              </p>
              <p (click)="goToInspection(inspection.InspectionRequestId)">
                <span>{{ inspection.ContractorName }}</span> -
                <span>{{ inspection.InspectionName }}</span>
              </p>
              <p (click)="goToInspection(inspection.InspectionRequestId)">
                <span>{{ inspection.InspectionDate | dateTimeFormat }}</span> -
                <span>{{ inspection.Status }}</span>
              </p>
            </div>
            <div
              style="margin-top: 15px; color: red"
              *ngIf="inspectionData.length === 0"
            >
              No Records Found!
            </div>
            <div class="col-sm-12 col-xs-12" *ngIf="showPagination">
              <pagination-controls
                (pageChange)="getServerData($event)"
              ></pagination-controls>
            </div>
          </div>
          <!-- End table-responsive -->
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<ara-alerts
  [alertType]="alertType"
  [successDetails]="successDetails"
  [errorDetails]="errorDetails"
  (yesClicked)="onYesClickedForConfirmation()"
  [confirmMessage]="confirmMessage"
  (noClicked)="onNoClickedForConfirmation()"
  (okClicked)="onOkClicked()"
></ara-alerts>
<p-contextMenu
  [appendTo]="row"
  [target]="row"
  #cm
  [model]="contextItems"
></p-contextMenu>
